<script setup>
import { ref, onMounted } from 'vue';
import { useAuthStore } from '@/modules/auth/store';
import { useRouter } from 'vue-router';
import NProgress from 'nprogress';
import { Products } from '../../../enums';

const router = useRouter();

const visible = ref(false);
const products = ref(null);
const authStore = useAuthStore();

const PHA_URL = process.env.VUE_APP_PROHEALTH_LINK;

onMounted(() => {
    // Gathers the list of product logged user have access to
    products.value = authStore.productList;
    // First of all, checks if user have access to only single product
    // Then check if the logged user have only one product access, if yes then select that directly and redirect them accordingly
    const defaultProductCode = Products.AMS;
    if (products.value?.some(product => product.code === defaultProductCode)) {
        selectProduct(defaultProductCode);
    } else {
        console.error('Default product AMS is not available in productList.');
    }
});

const selectProduct = (code) => {
    if (code === Products.AMS) {
        NProgress.start();
        authStore.selectProduct(code);
        visible.value = false;
        // push user to landing page once product is selected
        setTimeout(() => {
            NProgress.done();
            router.push('/');
        }, 2000);
    }
};
</script>

<template>
    <div class="h-screen">
        <div class="h-full card flex justify-content-center align-items-center">
            <div class="flex flex-column align-items-center">
                <div v-if="authStore.selectedProduct !== ''" class="w-30rem my-2">
                    <div class>
                        <div v-if="authStore.selectedProduct === 'PHA'" class="mt-5"></div>
                        <img v-if="authStore.selectedProduct" 
                            class="w-full" 
                            :src=" isGodUser ? `layout/images/products/${authStore.selectedProduct}.png` : authStore.companyLogoUrl" 
                            alt="active product image" 
                         />
                    </div>
                </div>
                <div v-else>
                    <h2>No active product selected</h2>
                </div>
                <div>
                    <PulseLoader class="my-2" v-if="authStore.selectedProduct" />
                    <h5>Loading into the system...</h5>
                </div>
            </div>
        </div>
        <Dialog
            v-model:visible="visible"
            modal
            :header="authStore.selectedProduct ? `${authStore.selectedProduct} is active` : 'You have access to the following products, choose one to continue'"
            :style="{ width: '50vw' }"
            @hide="$emit('hide-dialog', true)"
            :closable="false"
        >
            <div class="image-container">
                <div class="col-12 lg:col-4" v-for="product in products" :key="product.id" @click="selectProduct(product.code)">
                    <a v-if="product.code === Products.PHA" :href="PHA_URL" target="_blank">
                        <img v-if="product.code === Products.PHA" :src="'layout/images/products/' + product.code + '.png'" :alt="product.code + '-logo'" />
                    </a>
                    <img v-else :src="'layout/images/products/' + product.code + '.png'" :alt="product.code + '-logo'" />
                </div>
            </div>
        </Dialog>
    </div>
</template>

<style lang="scss">
.image-container {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 40vh;
    div:hover {
        border: 2px dotted black;
        height: 26vh;
        cursor: pointer;
    }
    img {
        width: 100%;
        height: 100%;
        object-fit: scale-down;
        margin: 0;
    }
}
</style>
